<!-- カルーセル -->
<template>
  <div v-if="bannerListData.length > 0 && isDataFetched" class="home_slider1">
    <carousel
      :autoplay="2500"
      :pauseAutoplayOnHover="true"
      :itemsToShow="itemsToShow"
      :wrapAround="true"
      :transition="500"
    >
      <slide v-for="banner in bannerListData" :key="banner.bannerName">
        <a :href="banner.bannerUrl" target="_blank" rel="noopener noreferrer">
          <img
            :src="appDir + `/images/${banner.bannerImgFileName}`"
            alt="banner.bannerName"
          />
        </a>
      </slide>
      <template #addons>
        <navigation />
        <pagination />
      </template>
    </carousel>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref, onUnmounted } from "vue";
import { AxiosError } from "axios";
import { Carousel, Slide, Pagination, Navigation } from "vue3-carousel";
import apiAuthClient from "@/util/apiClientAuth";
import { outputDebugLogs, formatMessage, getTargetDate } from "@/Common";
import { AppConstants } from "@/constants/AppConstants";
import messages from "@/assets/messages.json";
import "vue3-carousel/dist/carousel.css"; // デフォルトのスタイルをインポート

interface Item {
  bannerName: string;
  bannerCaption: string;
  bannerUrl: string;
  bannerImgFileName: string;
}

export default defineComponent({
  name: "CarouselComponent",
  components: {
    Carousel,
    Slide,
    Pagination,
    Navigation,
  },
  setup() {
    const bannerListData = ref<Item[]>([]);
    const errorMessage = ref("");
    const itemsToShow = ref(2.3);
    const isDataFetched = ref(false); // データが取得済みかどうかを追跡
    const updateItemsToShow = () => {
      const baseItemsToShow = 1.8; // 基本値
      const minItemToShow = 2.3; // 基本値
      var afterImageToShow = 0;
      const widthChangeFactor = 0.1; // 10pxあたりの変更量
      const widthChange = window.innerWidth - 1200; // 基準ウィンドウ幅との差
      afterImageToShow =
        baseItemsToShow + (widthChange / 40) * widthChangeFactor;
      if (minItemToShow > afterImageToShow) {
        return;
      } else {
        itemsToShow.value = afterImageToShow;
      }
    };

    const appDir = process.env.VUE_APP_DIR;

    onMounted(async () => {
      try {
        outputDebugLogs("カルーセル バナー取得");

        // バナーデータ取得API
        const response = await apiAuthClient.post("/api/Banner/getBannerList", {
          systemKbn: process.env.VUE_APP_SYSTEM_KBN,
          bannerKbn: AppConstants.BANNER_KBN_CAROUSEL,
          targetDate: getTargetDate(""),
        });
        bannerListData.value = response.data.bannerListData;
        outputDebugLogs(
          "カルーセル バナー取得成功 件数：" + bannerListData.value.length
        );

        // 初期表示時に itemsToShow を設定
        updateItemsToShow();
        // リサイズイベントの監視
        window.addEventListener("resize", updateItemsToShow);

        isDataFetched.value = true; // データが取得されたことを設定
      } catch (error: unknown) {
        const axiosError = error as AxiosError;
        outputDebugLogs("Error: " + axiosError.message);
        alert(formatMessage(messages.ERR_SYS003, "カルーセルデータの取得"));
      } finally {
        //何か入れるかも
      }
    });

    onUnmounted(() => {
      // コンポーネントがアンマウントされる際にリサイズイベントの監視を解除
      window.removeEventListener("resize", updateItemsToShow);
    });

    return {
      errorMessage,
      bannerListData,
      itemsToShow,
      updateItemsToShow,
      isDataFetched,
      appDir,
    };
  },
});
</script>
<style scoped>
.home_slider1 {
  margin: 0 0 25px;
  position: relative;
}

.home_slider1 .vue3-carousel__slide {
  padding: 0 0 15px;
  position: relative;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.home_slider1 .vue3-carousel__slide--active {
  opacity: 1;
}

.home_slider1 a {
  border-radius: 10px;
  box-shadow: 0 3px 5px 0 rgba(0, 0, 0, 0.1);
  display: block;
  height: auto;
  margin: 10px 22.5px;
  overflow: hidden;
  width: 580px;
}

.home_slider1 img {
  /*height: 200px;*/ /* 固定の高さ */
  height: 100%;
  transition: 0.5s ease;
  width: 100%;
}

.home_slider1 a:hover img {
  transform: scale(1.06);
  transform-origin: center center;
}

.home_slider1 .vue3-carousel__pagination {
  bottom: 0;
  display: flex;
  justify-content: center;
  gap: 9px;
  list-style: none;
  margin: 0;
  padding: 0;
  position: absolute;
  text-align: center;
  width: 100%;
}

.home_slider1 .carousel__pagination-button {
  background: transparent;
  appearance: none;
  border: 1px solid #777;
  border-radius: 50%;
  display: block;
  height: 8px;
  margin: 0;
  padding: 0;
  width: 8px;
}

.home_slider1 .vue3-carousel__pagination-button--active {
  background: #000;
  border-color: #000;
}
</style>
